<template>
  <WdsText class="tw-truncate" :text="date" :data-test="`supplier-updated-at-${rowIndex}`" />
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import { WdsText } from '@worksome/wds-components'
import { FragmentType, graphql, useFragment } from '@/gql'
import useDate from '@/composables/useDate'

const SupplierUpdatedAtColumn = graphql(`
  fragment SupplierUpdatedAtColumn on SupplierClient {
    id
    updatedAt
  }
`)

const props = defineProps<{
  row: FragmentType<typeof SupplierUpdatedAtColumn>
  rowIndex?: number
}>()

const column = computed(() => useFragment(SupplierUpdatedAtColumn, props.row))
const rowIndex = computed(() => props.rowIndex ?? 0)
const { date } = useDate(computed(() => column.value.updatedAt))
</script>
